import { httpClient } from '@/infra/protocols/http';
import { IEpisodeDetailsDTO } from '@/modules/episodes/dtos/episode.dto';
import { IEpisodeDetails } from '@/modules/episodes/entities/episode.entity';
import { EpisodeDetailsMapper } from '@/modules/episodes/mappers/episode-details.mapper';

export async function getEpisodeDetails(
  params: GetEpisodeDetailsService.Params,
): Promise<GetEpisodeDetailsService.Response> {
  const response = await httpClient.get<IEpisodeDetailsDTO>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}`,
  );
  return EpisodeDetailsMapper.toPresentation(response);
}

export namespace GetEpisodeDetailsService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
  }

  export type Response = IEpisodeDetails;
}
